/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_TitleInputs */

const cs_reports_title = /** @type {(inputs: Reports_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporty`)
};

const en_reports_title = /** @type {(inputs: Reports_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports`)
};

/**
* | output |
* | --- |
* | "Reports" |
*
* @param {Reports_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_title = /** @type {((inputs?: Reports_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_title(inputs)
	return cs_reports_title(inputs)
});